import {z} from 'zod'

export const RecurrenceSchema = z.enum(['DAILY', 'WEEKLY', 'MONTHLY'])

export type Recurrence = z.infer<typeof RecurrenceSchema>
